import React, { useRef, useEffect } from "react";
import "./style.scss";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { BsGithub } from "react-icons/bs";
gsap.registerPlugin(ScrollTrigger);

function About() {

    const imgRef = useRef(null);
    const paraRef = useRef(null);
    const infoRef = useRef(null);

    const calculateAge = (date) => {
        const actualDate = new Date();
        const birthDate = new Date(date);
        const difference = actualDate.getTime() - birthDate.getTime();
        return Math.floor(difference / (1000 * 60 * 60 * 24 * 365));
    }

    const age = calculateAge('1989-09-12');

    useEffect(() => {

        const AnimateObject = [imgRef, paraRef, infoRef];

        const gsapAnimation = (ref) => {
            gsap.fromTo(ref.current,
                {
                    y: "10rem",
                    opacity: 0.5,
                },
                {
                    y: "0rem", opacity: 1, duration: 1, scrollTrigger: {
                        trigger: ref.current,
                        toggleActions: 'restart none restart none',
                        start: `-600px center`,
                        end: `top center`,
                        scrub: 2,
                        markers: false,
                    }
                })
        }

        AnimateObject.map(item => {
            gsapAnimation(item);
            return item;
        })
    }, [imgRef, paraRef, infoRef])

    return (
        <section className="about" id="about">
            <div className="content">
                <div className="img__container" ref={imgRef}>
                    <img className="img" src="./img/Adrien_Blanco.webp" alt="portrait Adrien Blanco"></img>
                </div>
                <p className="paragraph" ref={paraRef}>
                    Hello world !<br />
                    Moi c'est Adrien, {age} ans, passionné par l'informatique, la culture Internet et les <span>dinosaures</span> depuis l'enfance.
                    <br />
                    <br />
                    Après un parcours dans <span>la communication, la relation client et la pédagogie</span>, c'est en 2022 que je saute le pas pour apprendre le <span>développement web front-end</span>.
                    <br />
                    Je rentre chez <span>OpenClassRooms</span> en tant qu'élève Intégrateur Web en <span>février 2023</span>.
                    Durant ma formation, j'ai touché à différents aspects du métier et j'ai pu me spécialiser en <span>React JS</span>.
                    <br />
                    <br />
                    Depuis le début d'année 2024 je suis autoentrepreneur et je réalise des <span>sites vitrines modernes et otpimisés</span> en utilisant principalement <span>React JS et Sass</span>. 

                </p>
                <div className="info" ref={infoRef}>
                    <a href="https://github.com/AdrienBlanco" target="_blank" rel="noopener noreferrer"><h2 className="name"><BsGithub className="github-i" /> AdrienBlanco</h2>
                        <span>Suivez-moi sur Github !</span></a>
                </div>
            </div>
        </section>
    );
};

export default About;